import React from "react"
import PropTypes from "prop-types"
import {get, capitalize} from "lodash"

import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import authentication from "@irati/auth"

const PROPERTY = "preferences.placeholders.tenant"

export const schema = Validation.string("This is required")

const _getTenantSpecificLabel = () => {
  return `Company / Department name e.g. ${capitalize(authentication.userTenant().subdomain)}`
}

const Tenant = ({survey, onChange, required, label = _getTenantSpecificLabel(), placeholder = _getTenantSpecificLabel(), ...props}) => {
  return (
    <Input
      name={PROPERTY}
      type="text"
      value={get(survey, PROPERTY)}
      onChange={(value) => onChange(survey, PROPERTY, value)}
      label={`${label}${required ? "*" : ""}`}
      placeholder={placeholder}
      {...props}
      id={id(PROPERTY, props)} />
  )
}

Tenant.propTypes = {
  survey: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  validation: PropTypes.object
}

Tenant.defaultProps = {
  required: true,
  hint: "We'll inject this name into the survey to customise the  question bank for your employees",
  validation: schema,
  id: PROPERTY
}

export default Tenant
